import Header from "../Components/Header";
import NewsPaper from "../Components/NewsPaper";

const Home = () => {
	return (
		<div className="HomePage">
			<Header />
			<NewsPaper />
		</div>
	);
};

export default Home;
